var $ = jQuery.noConflict();

$(window).on("load", function () {
  let method = "front";
  if ($("body").hasClass("wp-admin")) method = "wp-admin";

  var initializeBlock = function ($block) {
    // Open modal
    if (method === "front") {
      document.querySelectorAll(".block-modal").forEach((modal) => {
        modal.classList.add('js-ready');
        
        // Move modal to end of body
        document.body.appendChild(modal);

        const id = modal.id;
        const selector = '[href="#' + id + '"]';
        const buttons = Array.from(document.querySelectorAll(selector));
        const overlay = modal.querySelector(".block-modal__overlay");
        const closeBtn = modal.querySelector(".block-modal__close");

        const html = document.querySelector('html');
        
        const closeModal = () => {
          if (html) {
            html.style.overflow = '';
          }
          modal.setAttribute("aria-hidden", "true");
          const triggerButtonIndex = parseInt(modal.getAttribute("data-trigger-index"));
          buttons?.[triggerButtonIndex]?.focus();
        };

        const openModal = (triggerButtonIndex) => {
          if (html) {
            html.style.overflow = 'hidden';
          }
          modal.setAttribute("aria-hidden", "false");
          modal.setAttribute("data-trigger-index", triggerButtonIndex);
          setTimeout(() => { closeBtn.focus() }, 500);
        }

        buttons.forEach((button, index) => {
          button.addEventListener("click", function (e) {
            e.preventDefault();
            openModal(index);
          });
        });

        window.addEventListener("keydown", (e) => {
          if (e.key === "Escape") {
            closeModal();
          }
        }, { passive: true });

        closeBtn.addEventListener("click", closeModal);
        overlay.addEventListener("click", closeModal);
      });
    }
  };

  window.onload = (function () {
    initializeBlock($(this));
  })();

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=modal", initializeBlock);
  }
});
